import { FaqEntry } from './types';

const STOP_WORDS = new Set([
  'a', 'an', 'the', 'is', 'are', 'was', 'were', 'be', 'been', 'being',
  'have', 'has', 'had', 'do', 'does', 'did', 'will', 'would', 'could',
  'should', 'may', 'might', 'shall', 'can', 'to', 'of', 'in', 'for',
  'on', 'with', 'at', 'by', 'from', 'it', 'its', 'this', 'that',
  'i', 'me', 'my', 'we', 'our', 'you', 'your', 'he', 'she', 'they',
  'them', 'and', 'or', 'but', 'if', 'so', 'as', 'not', 'no',
  'what', 'how', 'where', 'when', 'who', 'which', 'there',
]);

export const MATCH_THRESHOLD = 0.4;

export interface OfflineMatchResult {
  answer: string;
  source: 'faq';
  score: number;
  matchedQuestion: string;
  offline: true;
}

export function tokenize(text: string): string[] {
  const normalized = text
    .toLowerCase()
    .replace(/[^\w\s]/g, '')
    .replace(/\s+/g, ' ')
    .trim();

  return normalized
    .split(' ')
    .filter((word) => word.length > 1 && !STOP_WORDS.has(word));
}

export function scoreEntry(questionKeywords: string[], entry: FaqEntry): number {
  if (questionKeywords.length === 0) return 0;

  const matchingKeywords = questionKeywords.filter((qk) =>
    entry.keywords.some((ek) => qk.includes(ek) || ek.includes(qk)),
  );

  return matchingKeywords.length / questionKeywords.length;
}

export function matchFaq(question: string, faqEntries: FaqEntry[]): OfflineMatchResult | null {
  const questionKeywords = tokenize(question);
  if (questionKeywords.length === 0) return null;

  let bestMatch: OfflineMatchResult | null = null;
  let bestScore = 0;

  for (const entry of faqEntries) {
    const score = scoreEntry(questionKeywords, entry);
    if (score > bestScore) {
      bestScore = score;
      bestMatch = {
        answer: entry.answer,
        source: 'faq',
        score,
        matchedQuestion: entry.question,
        offline: true,
      };
    }
  }

  return bestMatch && bestScore > MATCH_THRESHOLD ? bestMatch : null;
}
